import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import clientApi from '../../api/client';
import { apiDefine } from '../../api/web';
import weixinConfig from '../../utils/weixinConfig';
import AXIOS from '../../api/axios';
import shareBpWrapper from '../../hoc/shareBp';

import './style.less';
class webviewPage extends Component {
    constructor(props){
        super(props);
        const { query: { courseId, userId } = {} } = this.props.location;
        this.state = {
            backRequired: false,
            url: 'http://www.baidu.com',
            shareParams: {},
            userId: userId || window.localStorage.getItem('ac_id'),
            token: userId || window.localStorage.getItem('ac_token'),
            courseId
        }
    }
    componentDidMount(){
        const { courseId } = this.state;
        const key = `${courseId}_UnitReport`;
        apiDefine({ apiName:'backConfirm', fn:this.backConfirm }); // 退出二次确认
        apiDefine({ apiName: 'alertViewBack', fn: this.alertViewBack }); // 定义弹框回调方法
        AXIOS.getShareConfig({ key }, (res, err) => {
            const shareParams = res[key] || {};
            const { description: desc, shortTitledd: title, icon: imgUrl } = shareParams;
            this.setState({ shareParams });

            const wxConfig = {
                title,
                desc,
                imgUrl,
                link: encodeURI(`${window.location.href}`),
            }
            weixinConfig(wxConfig,(type) => {
                this.props.sendShareBp(type)
            });
        })
    }
    openBroswer = () => {
        const { url, token } = this.state;
        clientApi.openBroswer({ url: url + '?token=' + window.btoa(token) });
    }
    handleClick = () => {
        this.props.sendShareBp(1)
    }
    backRequire = (e) => {
        const backRequired = e.target.checked;
        this.setState({ backRequired });
        clientApi.backRequired({ backRequired });
    }
    backConfirm = () => {
        clientApi.alertView({
            content: '确认退出吗',
            confirm: '确定',
            cancel: '取消',
            id: 'H5_1006'
        });
    }
    alertViewBack = (res) => {
        const data = JSON.parse(res);
        if(data.select === 'confirm'){
            clientApi.closeH5Page({ reason: 'closeSafe' });
        }
    }
    render(){
        return(
            <DocumentTitle title={'客户端接口测试'}>
                <div className="container test">
                    <ul>
                        <li>
                            <label>退出二次确认：<input type="checkbox" onChange={this.backRequire.bind(this)} /></label>
                        </li>
                        <li onClick={this.openBroswer}>打开外部浏览器</li>
                        <li onClick={this.handleClick}>点击按钮（埋点）</li>
                    </ul>
                </div>
            </DocumentTitle>
        )
    }
}

export default shareBpWrapper(webviewPage, { courseId: 230, url: window.location.href, key: 'H5_testPage'})



// WEBPACK FOOTER //
// ./src/components/testPage/webview.jsx